import { useRef, useState } from "react";
import { Container } from "react-bootstrap";
import { Skeleton } from '@mui/material';
import { Footer, NavBar, NewButton } from '../components';
import { PartnerCards, PartnerForm } from "../components";
import { tracking } from '../../../utils/tracking';
import { useResizeImg } from '../../../utils/useResizeImg';
import styles from "./Partners.module.css";

const DESKTOP_IMG_URL = '../../../../assets/events/etvs23/partners-banner-desktop.jpg'
const MOBILE_IMG_URL = '../../../../assets/events/etvs23/partners-banner-mobile.jpg'

export const Partners = () => {
   document.title = "Emerging Tech Venture Summit | Partners";
   const [isLoading, setIsLoading] = useState(true);
   const myDiv = useRef(null);
   const imageSource = useResizeImg(DESKTOP_IMG_URL, MOBILE_IMG_URL)


   return (
      <div>
         <NavBar />
         <Container className={styles.banner} fluid>
            {isLoading ?
               <Skeleton animation="wave" variant="rectangular" sx={{ minHeight: imageSource === DESKTOP_IMG_URL ? '65vh' : '100vh', position: 'initial !important', backgroundColor: '#0F1A28' }} >
                  <div id="etxLoader" style={{ left: window.innerWidth > 900 ? '45%' : '40%', top: '40%' }} />
                  <img
                     onLoad={() => setIsLoading(false)}
                     src={imageSource}
                     alt='home-img'
                     style={{ visibility: 'hidden', minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
                  />
               </Skeleton>
               :
               <img
                  src={imageSource}
                  loading="eager"
                  alt='home-img'
                  style={{ minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
               />

            }
            {
               !isLoading &&
               <div className={styles.itemsOnImg}>
                  <h2 >Partners</h2>
                  <h3 >Why Partner with us?</h3>
                  <section>
                     Exposure &nbsp;
                     <span style={{ color: "#CF1B5B" }}>&gt;</span>
                     &nbsp; Value &nbsp; <span style={{ color: "#CF1B5B" }}>&gt;</span>&nbsp; Recognition
                  </section>
                  <div onClick={() => { tracking(291); myDiv.current.scrollIntoView({ behavior: 'smooth' }) }} className={styles.btn}>
                     <NewButton name='REQUEST INFO' color='#CF1B5B' bgColor='white' borderColor='none' fontSize />
                  </div>
               </div>
            }
         </Container>
         <PartnerCards />
         <div ref={myDiv} style={{ height: '50px', width: '100%' }} />
         <PartnerForm />
         <Footer />
      </div>
   );
};
